import 'core-js/features/object/assign';

import $ from 'jquery';
import ModuleService from './ModuleService';
import MindMap from './MindMap';
import Posts from './Posts';
import DropdownListItem from './DropdownListItem';
import ToggleTabs from './ToggleTabs';

function init()
{
    const modules = new ModuleService();

    modules.register('hogo_mind_map', MindMap);
    modules.register('hogo_posts', Posts);
    modules.register('hogo_dropdown_list_item', DropdownListItem);
    modules.register('hogo_tabs_toggle', ToggleTabs);
}


$(window).on('elementor/frontend/init', init);